"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseItemsFeedQuery = void 0;
var models_1 = require("../../models");
var base_item_query_class_1 = require("../item/base-item-query.class");
var BaseItemsFeedQuery = /** @class */ (function (_super) {
    __extends(BaseItemsFeedQuery, _super);
    function BaseItemsFeedQuery(config, queryService) {
        var _this = _super.call(this, config, queryService) || this;
        _this.config = config;
        _this.queryService = queryService;
        return _this;
    }
    /**
     * Gets only item of given type
     * @param type Codename of type to get
     */
    BaseItemsFeedQuery.prototype.type = function (type) {
        this.parameters.push(new models_1.Filters.TypeFilter(type));
        return this;
    };
    /**
     * Gets items of given types (logical or)
     * I.e. get items of either 'Actor' or 'Movie' type
     * @param types Types to get
     */
    BaseItemsFeedQuery.prototype.types = function (types) {
        this.parameters.push(new models_1.Filters.TypeFilter(types));
        return this;
    };
    /**
     * Equals filter condition
     * @param element Element to filter. Example: 'elements.movie'
     * @param value Value to match. Example: 'Kingsman'
     */
    BaseItemsFeedQuery.prototype.equalsFilter = function (element, value) {
        this.parameters.push(new models_1.Filters.EqualsFilter(element, value));
        return this;
    };
    /**
     * All filter
     * @param element Element to filter.
     * @param values Values
     */
    BaseItemsFeedQuery.prototype.allFilter = function (element, values) {
        this.parameters.push(new models_1.Filters.AllFilter(element, values));
        return this;
    };
    /**
     * Any filter
     * @param element Element to filter.
     * @param values Values
     */
    BaseItemsFeedQuery.prototype.anyFilter = function (element, values) {
        this.parameters.push(new models_1.Filters.AnyFilter(element, values));
        return this;
    };
    /**
     * Contains filter
     * @param element Element to filter.
     * @param values Values
     */
    BaseItemsFeedQuery.prototype.containsFilter = function (element, values) {
        this.parameters.push(new models_1.Filters.ContainsFilter(element, values));
        return this;
    };
    /**
     * Greater then filter
     * @param element Element to filter.
     * @param value Value
     */
    BaseItemsFeedQuery.prototype.greaterThanFilter = function (element, value) {
        this.parameters.push(new models_1.Filters.GreaterThanFilter(element, value));
        return this;
    };
    /**
     * Greater then or equals filter
     * @param element Element to filter.
     * @param value Value
     */
    BaseItemsFeedQuery.prototype.greaterThanOrEqualFilter = function (element, value) {
        this.parameters.push(new models_1.Filters.GreaterThanOrEqualFilter(element, value));
        return this;
    };
    /**
     * In filter
     * @param element Element to filter.
     * @param values Values
     */
    BaseItemsFeedQuery.prototype.inFilter = function (element, values) {
        this.parameters.push(new models_1.Filters.InFilter(element, values));
        return this;
    };
    /**
     * Less then filter
     * @param element Element to filter.
     * @param value Value
     */
    BaseItemsFeedQuery.prototype.lessThanFilter = function (element, value) {
        this.parameters.push(new models_1.Filters.LessThanFilter(element, value));
        return this;
    };
    /**
     * @param element Element to filter.
     * @param value Value
     */
    BaseItemsFeedQuery.prototype.lessThanOrEqualFilter = function (element, value) {
        this.parameters.push(new models_1.Filters.LessThanOrEqualFilter(element, value));
        return this;
    };
    /**
     * @param element Element to filter.
     * @param lowerValue Lower value of range (e.g. 2)
     * @param higherValue Higher value of range (e.g. 10)
     */
    BaseItemsFeedQuery.prototype.rangeFilter = function (element, lowerValue, higherValue) {
        this.parameters.push(new models_1.Filters.RangeFilter(element, lowerValue, higherValue));
        return this;
    };
    /**
     * Orders query based on given element and sort order
     * @param element Element by which to order
     * @param sortOrder Asc/Desc order type
     */
    BaseItemsFeedQuery.prototype.orderParameter = function (element, sortOrder) {
        this.parameters.push(new models_1.Parameters.OrderParameter(element, sortOrder));
        return this;
    };
    /**
     * Sets descending order on given element
     * @param element Element by which to order
     */
    BaseItemsFeedQuery.prototype.orderByDescending = function (element) {
        this.parameters.push(new models_1.Parameters.OrderParameter(element, models_1.SortOrder.desc));
        return this;
    };
    /**
     * Sets Ascending order on given element
     * @param element Element by which to order
     */
    BaseItemsFeedQuery.prototype.orderByAscending = function (element) {
        this.parameters.push(new models_1.Parameters.OrderParameter(element, models_1.SortOrder.asc));
        return this;
    };
    return BaseItemsFeedQuery;
}(base_item_query_class_1.BaseItemQuery));
exports.BaseItemsFeedQuery = BaseItemsFeedQuery;
//# sourceMappingURL=base-items-feed-query.class.js.map